/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__Zone_disable_customElements = true;

/**
 * Unpatch high-frequency pointer events from Zone.js. Without this, iOS WebKit
 * fires touchmove at ~60Hz during scrolling and slide animations -> each
 * event goes through NgZone -> ApplicationRef.tick() -> full Default-CD walk
 * over OrderPage (Default CD) + every visible Stencil component.
 *
 * Audited: zero (touchmove)/(touchstart)/(touchend)/(pointermove) template
 * bindings in src/app/. Four modalContent.ontouchmove = e => e.stopPropagation()
 * assignments do not need Zone tick.
 */
// eslint-disable-next-line no-underscore-dangle
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'scroll',
  'mousemove',
  'pointermove',
  'touchmove',
  'touchstart',
  'touchend',
  'touchcancel',
];
